import { Box, Container, Heading } from '@hover/blueprint';
import React from 'react';
import AboutHoverStatistic from './AboutHoverStatistic';
import AboutHoverInvestors from './AboutHoverInvestors';
import AboutHoverWorkWithUs from './AboutHoverWorkWithUs';

const AboutHover: React.FC = () => (
  <Box bg="green.100" mt={{ desktop: 800 }} pb="70px" w="100%">
    <Container
      maxW="1248px"
      overflow="hidden"
      px={{ base: 500, tablet: '56px', desktop: 500 }}
    >
      <Box
        flexDir="column"
        alignItems={{ base: 'center', tablet: 'flex-start' }}
      >
        <Heading
          maxW="6xl"
          fontWeight={{ base: 600, desktop: 700 }}
          size={{ base: 500, tablet: 600, desktop: 700 }}
          mt={{ base: 700, tablet: 1000 }}
          mb={700}
          textAlign={{ base: 'center', tablet: 'left' }}
        >
          HOVER is headquartered in San Francisco, with an office in Rochester,
          NY and employees distributed across the US.
        </Heading>
        <AboutHoverWorkWithUs />
      </Box>
      <AboutHoverStatistic />
      <AboutHoverInvestors />
    </Container>
  </Box>
);

export default AboutHover;
